// After a deploy, Vite's hashed chunks from the previous build are gone. A tab
// still running the old build (or one that loaded a cached index.html) then
// fails the moment it lazy-loads a route, and Firebase Hosting answers the
// missing chunk with index.html, so the browser rejects it as a bad module.
// Reloading picks up the new build.

const STALE_BUILD_PATTERN =
  /dynamically imported module|importing a module script failed|unable to preload css|valid javascript mime type|loading (css )?chunk/i;

const RELOAD_KEY = "staleBuildReloadAt";
// Long enough that a reload which doesn't fix things doesn't loop forever.
const RELOAD_COOLDOWN_MS = 30_000;

export function isStaleBuildError(error: unknown): boolean {
  if (error instanceof Error) {
    return STALE_BUILD_PATTERN.test(`${error.name} ${error.message}`);
  }
  return typeof error === "string" && STALE_BUILD_PATTERN.test(error);
}

export function reloadPage() {
  window.location.reload();
}

/**
 * Reloads to fetch the new build, unless we already did so recently.
 * Returns whether a reload was triggered.
 */
export function reloadForNewBuild(now = Date.now()): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
    if (now - last < RELOAD_COOLDOWN_MS) return false;
    sessionStorage.setItem(RELOAD_KEY, String(now));
  } catch {
    // No sessionStorage (private mode etc.); without a guard, don't risk a loop.
    return false;
  }
  reloadPage();
  return true;
}
